module.exports = __webpack_public_path__ + "static/Giant_Frost-a93783c03736b7fd72c5f0bb4562ce5e.jpg";